import { AxiosError } from "axios";

import { LogOperation } from "../../utils/entities/logOperation";
import api from "../api";
import { returnResponse } from "../utils";

export const hearingTypeAttendantRole = {
  getAllRelationsProcedureCustomerTypeAttendantRole: async (
    customerId: number,
    hearingType: number,
  ) => {
    if (!customerId || !hearingType) {
      return {
        status: false,
        message: "Não é possivel vincular sem o customer e o procedurecustomer",
      };
    }

    try {
      const { data } = await api.get(
        `/v1/HearingTypeAttendantRole/GetHearingTypeAttendantRoleRelation`,
        {
          params: {
            customerId,
            hearingType: hearingType,
          },
        },
      );

      return {
        success: true,
        data: data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: error?.response?.data.message,
        });

        return {
          success: false,
          severity,
          status,
          body: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  vincularHearingTypeEAttendantRole: async (
    customerId: number,
    hearingTypeId: number,
    attendantRoleId: number,
  ) => {
    if (!customerId || !hearingTypeId || !attendantRoleId) {
      return {
        status: false,
        message: "Não é possivel vincular sem o customer e o procedurecustomer",
      };
    }

    try {
      const { data } = await api.post(`/v1/HearingTypeAttendantRole/Add`, {
        customerId,
        hearingTypeId,
        attendantRoleId,
        device: LogOperation.getDevice(),
        ip: LogOperation.getMachineIP(),
        logPoliceUnitId: LogOperation.getPoliceUnitId(),
        logUserId: LogOperation.getUserId(),
      });
      return {
        success: true,
        body: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: error?.response?.data.message,
        });

        return {
          success: false,
          severity,
          status,
          body: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  deletarVinculoHearingTypeEAttendantRole: async (id: number) => {
    if (!id) {
      return {
        status: false,
        message: "Não é possivel deletar",
      };
    }

    try {
      await api.delete(`/v1/HearingTypeAttendantRole/Delete`, {
        params: {
          id,
        },
      });

      return {
        success: true,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: error?.response?.data.message,
        });

        return {
          success: false,
          severity,
          status,
          body: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  getAll: async (
    customerId: number,
    active: number,
    pageNumber?: number,
    pageSize?: number,
    searchTerm?: string,
  ) => {
    try {
      const queryParams = new URLSearchParams({
        customerId: String(customerId),
      });

      if (active !== undefined && active !== 2) {
        queryParams.append("active", String(active));
      }
      if (pageNumber !== undefined) {
        queryParams.append("pageNumber", String(pageNumber));
      }
      if (pageSize !== undefined) {
        queryParams.append("pageSize", String(pageSize));
      }
      if (searchTerm) {
        queryParams.append("searchTerm", searchTerm);
      }

      const { data } = await api.get<any>(
        `/v1/HearingType/GetAllByCustomerId?${queryParams.toString()}`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }
    }
  },
};
